export interface AuthorizationRequestModel {
  authProvider: string;
  token: string;
}
